module.exports = __webpack_public_path__ + "img/Image03.bc759f62.jpg";